import { getQaSelector } from '../../../../../../utils/common'
import Text from '../../../../../Text'
import { ApplicantReadMoreText } from '../../ApplicantReadMoreText'
import {
  APPLICANT_DECISION_NOTE_CLAMP_LINES,
  QA_NAME_APPLICANT_DECISION_NOTE,
} from '../ApplicantDecisionPanel.constants'

import * as styles from './ApplicantDecisionNote.module.css'

function ApplicantDecisionNote({ label, text }) {
  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_DECISION_NOTE })}
      className={styles.ApplicantDecisionNote}
    >
      <Text isSecondary className={styles.label}>
        {label}
      </Text>
      <ApplicantReadMoreText
        maxLines={APPLICANT_DECISION_NOTE_CLAMP_LINES}
        text={text}
      />
    </div>
  )
}

export default ApplicantDecisionNote
